import Vue from 'vue';
import * as types from '../mutation-types';

const tableBaseState = {
  rows: [],
  count: 0,
  page: 1,
  perPage: 10,
  enablePagination: true,
  ready: false,
  sorting: {
    prop: null,
    order: null,
  },
  enabledColumns: [],
  stickyColumns: [],
};

const initialState = {
  tablesStatus: {
    users: { ...tableBaseState },
    roles: { ...tableBaseState },
    operations: { ...tableBaseState },
    receivedSamples: { ...tableBaseState },
    quarantine: { ...tableBaseState },
    insertAnalysesData: { ...tableBaseState },
    // sampleDetails: { ...tableBaseState },
    analysesStatus: { ...tableBaseState },
    groupings: { ...tableBaseState },
    thermostats: { ...tableBaseState },
    offers: { ...tableBaseState },
    tasks: { ...tableBaseState },
    signatureRecipients: { ...tableBaseState },
    signDocuments: { ...tableBaseState },
    signatureProfiles: { ...tableBaseState },
    approvalCustomerChanges: { ...tableBaseState },
    locationsManagement: { ...tableBaseState },
    sectorsAssociation: { ...tableBaseState },
    defaultLocations: { ...tableBaseState },
    customerSampleAnalyses: { ...tableBaseState },
    customersLocations: { ...tableBaseState },
    familyTypes: { ...tableBaseState },
    specifications: { ...tableBaseState },
    changeLog: { ...tableBaseState },
    symbolSearch: { ...tableBaseState },
    analysesThermostatsSearch: { ...tableBaseState },
    stabilityConfigurations: { ...tableBaseState },
    advancedRevision: { ...tableBaseState },
  },
};

const tablesState = { ...initialState };

const getters = {
  tablesStatus: (state) => state.tablesStatus,
  tableParams: (state) => (listKey) => {
    const table = state.tablesStatus[listKey];
    return {
      sortBy: table.sorting,
      rows: table.rows,
      count: table.count,
      page: table.page,
      perPage: table.perPage,
      enablePagination: table.enablePagination,
      ready: table.ready,
    };
  },
  tableFilters: (state) => (listKey) => {
    const table = state.tablesStatus[listKey];
    const tableFilters = table.enablePagination
      ? {
          offset: (table.page - 1) * table.perPage,
          limit: table.perPage,
        }
      : {};
    if (table.sorting.order && table.sorting.prop) {
      tableFilters.order = [
        `${table.sorting.prop}  ${
          table.sorting.order === 'descending' ? 'DESC' : 'ASC'
        }`,
      ];
    }
    return tableFilters;
  },
  enabledColumns: (state) => (listKey) => {
    const table = state.tablesStatus[listKey];
    return table.enabledColumns;
  },
  stickyColumns: (state) => (listKey) => {
    const table = state.tablesStatus[listKey];
    return table.stickyColumns || [];
  },
};

const actions = {
  updateTablesStatus({ commit }, { tableKey, name, value }) {
    commit(types.UPDATE_TABLES_STATUS, { tableKey, name, value });
  },
  updateTableSorting({ commit }, { tableKey, sorting }) {
    commit(types.UPDATE_TABLE_SORTING, { tableKey, sorting });
  },
  updateTableCurrentPage({ commit }, { tableKey, page }) {
    commit(types.UPDATE_TABLE_CURRENT_PAGE, { tableKey, page });
  },
  updateTablePerPage({ commit }, { tableKey, perPage }) {
    commit(types.UPDATE_TABLE_PER_PAGE, { tableKey, perPage });
  },
  updateTableCount({ commit }, { tableKey, count }) {
    commit(types.UPDATE_TABLE_COUNT, { tableKey, count });
  },
  updateTableRows({ commit }, { tableKey, rows }) {
    commit(types.UPDATE_TABLE_ROWS, { tableKey, rows });
  },
  updateTableReady({ commit }, { tableKey, ready }) {
    commit(types.UPDATE_TABLE_READY, { tableKey, ready });
  },
  updateTableColumnsConfig({ commit }, { tableKey, config }) {
    commit(types.UPDATE_TABLE_COLUMNS_CONFIG, { tableKey, config });
  },
  updateTableStickyColumns({ commit }, { tableKey, config }) {
    commit(types.UPDATE_TABLE_STICKY_COLUMNS, { tableKey, config });
  },
  updateTableEnablePagination({ commit }, { tableKey, status }) {
    commit(types.UPDATE_TABLE_ENABLE_PAGINATION, { tableKey, status });
  },
  addTable({ commit }, { tableKey }) {
    // if (!state.tablesStatus[tableKey]) {
    commit(types.ADD_TABLE, { tableKey });
    // }
  },
  removeTable({ commit }, { tableKey }) {
    commit(types.REMOVE_TABLE, { tableKey });
  },
  resetTable({ dispatch }, tableKey) {
    dispatch('updateTableRows', { tableKey, rows: [] });
    dispatch('updateTableCount', { tableKey, count: 0 });
    dispatch('updateTableCurrentPage', { tableKey, page: 1 });
    dispatch('updateTablePerPage', { tableKey, perPage: 10 });
    dispatch('updateTableReady', { tableKey, ready: false });
    dispatch('updateTableSorting', {
      tableKey,
      sorting: { prop: null, order: null },
    });
    dispatch('updateTableColumnsConfig', { tableKey, config: [] });
    dispatch('updateTableStickyColumns', { tableKey, config: [] });
    dispatch('updateTableEnablePagination', { tableKey, status: true });
  },
  resetAllTables({ dispatch }) {
    Object.keys(tablesState.tablesStatus).forEach((tableKey) => {
      dispatch('resetTable', tableKey);
    });
  },
};

const mutations = {
  [types.UPDATE_TABLES_STATUS](state, { tableKey, name, value }) {
    state.tablesStatus[tableKey] = {
      ...state.tablesStatus[tableKey],
      [name]: value,
    };
  },
  [types.UPDATE_TABLE_SORTING](state, { tableKey, sorting }) {
    state.tablesStatus[tableKey] = { ...state.tablesStatus[tableKey], sorting };
  },
  [types.UPDATE_TABLE_CURRENT_PAGE](state, { tableKey, page }) {
    state.tablesStatus[tableKey] = { ...state.tablesStatus[tableKey], page };
  },
  [types.UPDATE_TABLE_PER_PAGE](state, { tableKey, perPage }) {
    state.tablesStatus[tableKey] = { ...state.tablesStatus[tableKey], perPage };
  },
  [types.UPDATE_TABLE_COUNT](state, { tableKey, count }) {
    state.tablesStatus[tableKey] = { ...state.tablesStatus[tableKey], count };
  },
  [types.UPDATE_TABLE_ROWS](state, { tableKey, rows }) {
    state.tablesStatus[tableKey] = { ...state.tablesStatus[tableKey], rows };
  },
  [types.UPDATE_TABLE_READY](state, { tableKey, ready }) {
    state.tablesStatus[tableKey] = { ...state.tablesStatus[tableKey], ready };
  },
  [types.UPDATE_TABLE_COLUMNS_CONFIG](state, { tableKey, config }) {
    state.tablesStatus[tableKey].enabledColumns = config;
  },
  [types.UPDATE_TABLE_STICKY_COLUMNS](state, { tableKey, config }) {
    state.tablesStatus[tableKey] = {
      ...state.tablesStatus[tableKey],
      stickyColumns: config,
    };
  },
  [types.UPDATE_TABLE_ENABLE_PAGINATION](state, { tableKey, status }) {
    state.tablesStatus[tableKey].enablePagination = status;
  },
  [types.ADD_TABLE](state, { tableKey }) {
    state.tablesStatus = {
      ...state.tablesStatus,
      [tableKey]: { ...tableBaseState },
    };
  },
  [types.REMOVE_TABLE](state, { tableKey }) {
    Vue.delete(state.tablesStatus, tableKey);
  },
};

export default {
  state: tablesState,
  getters,
  actions,
  mutations,
};
